
<script setup lang="ts">
import Offcanvas from '@/components/Offcanvas.vue';
import { info } from '@/lib/init';
import { onMounted, ref } from 'vue';

interface Item {
    'label': string;
    'url': string;
    'id': string;
    'sublabel': string;
    'sub': Item[];
}
interface Props {
    list: Item[];
    location?: string;
}
const { list, location } = withDefaults(defineProps<Props>(), {
    location: '',
});

const baseUrl = info().url?.base.absolute;
const columnOne = () => {
    return list.slice(0, 2)
}
const columnTwo = () => {
    return list.slice(2, 4)
}
const columnThree = () => {
    return list.slice(5, 7)
}
const teamItem = list[4];
const offElt = ref<any>(null)

onMounted(() => {
    const projectsScrollElement = document.getElementById('projectsScroll') as HTMLElement

    if (projectsScrollElement) {
        projectsScrollElement.addEventListener('click', () => {

            offElt?.value.close()
        });
    }
})




</script>
<style scoped lang="scss"></style>
<template>
    <Offcanvas container type="top" ref="offElt">
        <template #button>
            <div class="burger"></div>
        </template>
        <template #logo>
            <a :href='baseUrl' class="cnd-logo">
                <div class="logo"></div>
            </a>
        </template>
        <template v-if="list.length > 0">
            <div class="container">
                <div class="row">
                    <div class="column col-4">
                        <div class="row">
                            <div v-for="(item, index) in columnOne()" :key="index" class="col-12" :id="item.id">
                                <a :href="item.url">
                                    <p>{{ item.sublabel }}</p>
                                    <h3>
                                        {{ item.label }}
                                    </h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="column col-4">
                        <div v-for="(item, index) in columnTwo()" :key="index" class="vertical-item" :id="item.id">
                            <a :href="item.url">
                                <p>{{ item.sublabel }}</p>
                                <h3>
                                    {{ item.label }}
                                </h3>
                            </a>
                       <!--    <template v-if="index == 1">
                                <a :href="teamItem.url">
                                    <p>{{ teamItem.sublabel }}</p>
                                    <h3>
                                        {{ teamItem.label }}
                                    </h3>
                                </a>
                            </template>--> 
                        </div>
                    </div>
                    <div class="column col-4">
                        <div class="row">
                            <div v-for="(item, index) in columnThree()" :key="index" class="col-12" :id="item.id">
                                <a :href="item.url">
                                    <p>{{ item.sublabel }}</p>
                                    <h3>{{ item.label }}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Offcanvas>
</template>
